<template><div><h1>VUX V2.5.1 released</h1>
<h2><a href="/en/components/group.html">Group</a></h2>
<ul><li>[feature] Add slot:title #1650</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] Fix array-from issue with webpack@3 #1649</li>
</ul>
<h2><a href="/en/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] Add method:updateAutosize</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] Fix style missing #1659</li>
</ul>
<h2><a href="/en/components/transfer-dom.html">TransferDom</a></h2>
<ul><li>[enhance] Do not re-render on event:componentUpdated</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.1-110.vue?0eb6c85e